
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.076 14.311c-.033-3.282 2.677-4.857 2.798-4.935-1.523-2.228-3.896-2.534-4.741-2.569-2.02-.204-3.94 1.19-4.966 1.19-1.023 0-2.604-1.16-4.278-1.128-2.2.032-4.23 1.28-5.364 3.25C-.76 14.086.94 19.965 3.17 23.182c1.088 1.575 2.386 3.344 4.091 3.281 1.642-.065 2.263-1.063 4.248-1.063 1.985 0 2.542 1.063 4.28 1.03 1.766-.033 2.885-1.607 3.967-3.187 1.25-1.828 1.764-3.595 1.795-3.686-.04-.018-3.445-1.322-3.48-5.244l.006-.002zm-3.264-9.635c.905-1.097 1.516-2.62 1.349-4.14-1.303.053-2.883.868-3.819 1.964-.84.973-1.573 2.523-1.377 4.012 1.455.113 2.941-.74 3.846-1.834l.001-.002z","fill":"#000"}})])
          )
        }
      }
    